import { type ApiResponseData } from '@/common/types/http'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiResponseData = (dataToken: any): dataToken is ApiResponseData => {
  return dataToken !== null && typeof dataToken === 'object' && 'key' in dataToken
}
